export default [{
  path: '/',
  name: 'home',
  redirect: {
    name: 'login',
  },
  meta: {
    authPage: true,
  },
},
{
  path: '/dashboard',
  name: 'dashboard',
  component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardPage.vue'),
},
{
  path: '/issues',
  name: 'issues',
  component: () => import(/* webpackChunkName: "issues" */ '../views/MilestonesPage.vue'),
  meta: {},
},
{
  path: '/goals',
  name: 'goals',
  component: () => import(/* webpackChunkName: "goals" */ '../views/EmptyPage.vue'),
  meta: {},
},
{
  path: '/estimates',
  name: 'estimates',
  component: () => import(/* webpackChunkName: "estimates" */ '../views/EstimatesListPage.vue'),
  meta: {},
},
{
  path: '/timesheets',
  name: 'all-timesheets-list',
  component: () => import(/* webpackChunkName: "all-timesheets-list" */ '../views/TimesheetsListPage.vue'),
  meta: {},
},
{
  path: '/expenses',
  name: 'all-expenses-list',
  component: () => import(/* webpackChunkName: "all-expenses-list" */ '../views/ExpensesListPage.vue'),
  meta: {},
},
];
